module.exports = __webpack_public_path__ + "img/not_found (6).13b0d466.jpg";